import { useWizard } from '../../../context/WizardContext'
import { SERVICES } from '../../../utils/service'

/**
 * Two cards, and nothing else on the screen.
 *
 * A radio group rendered as radios would be two small circles and two lines of text —
 * correct, and a target the size of a fingernail for someone whose hands are not steady.
 * These are the whole card, 100px tall, and the entire surface is the button.
 *
 * The markup underneath is still a radio group, so the keyboard and a screen reader get
 * the semantics the appearance is hiding: arrow keys move between them, and the group is
 * announced as one choice rather than two unrelated buttons.
 */

const ICONS = {
  // A shopping bag and a sealed box. Drawn here rather than pulled from an icon set,
  // because two icons is not a dependency's worth of reason.
  pabili: (
    <path d="M6 8h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 8Zm3 0V6a3 3 0 0 1 6 0v2" />
  ),
  padala: (
    <path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7Zm0 0 8 4.5m0 0 8-4.5m-8 4.5V20" />
  ),
}

export default function ServiceStep() {
  const { state, errors, setService } = useWizard()

  return (
    <div role="radiogroup" aria-label="Serbisyo" className="grid gap-3">
      {SERVICES.map((service) => {
        const chosen = state.service === service.value

        return (
          <button
            key={service.value}
            type="button"
            role="radio"
            aria-checked={chosen}
            onClick={() => setService(service.value)}
            className={`flex items-start gap-3.5 text-left rounded-card border px-4 py-4
                        transition-colors duration-quick ease-out
                        ${chosen
                          ? 'border-brand bg-blush'
                          : 'border-edge bg-surface hover:border-brand'}`}
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`w-7 h-7 flex-none mt-0.5 ${chosen ? 'text-brand' : 'text-ink-3'}`}
            >
              {ICONS[service.value]}
            </svg>

            <span className="min-w-0">
              <span className={`block text-body font-semibold ${chosen ? 'text-brand' : 'text-ink'}`}>
                {service.label}
              </span>
              <span className="block mt-1 text-body-s text-ink-2">{service.hint}</span>
            </span>
          </button>
        )
      })}

      {errors.service && (
        <p role="alert" className="text-body-s text-alert">
          {errors.service}
        </p>
      )}
    </div>
  )
}
